module.exports = __webpack_public_path__ + "static/media/exclamacao-icon_2_.b48cd059.png";